import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';

// Google Maps embed without API key using the classic /maps?q= embed endpoint
export default function MapEmbed({ query, title = 'Location', height = 340 }) {
  const encoded = encodeURIComponent(query);
  const embedSrc = `https://maps.google.com/maps?q=${encoded}&t=&z=16&ie=UTF8&iwloc=&output=embed`;
  const openLink = `https://www.google.com/maps/search/?api=1&query=${encoded}`;

  return (
    <div className="relative rounded-md overflow-hidden border border-[color:var(--line)] shadow-sm group">
      <iframe
        title={title}
        src={embedSrc}
        width="100%"
        height={height}
        style={{ border: 0, display: 'block' }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      <a
        href={openLink}
        target="_blank"
        rel="noreferrer"
        className="absolute top-3 right-3 bg-white/95 backdrop-blur px-3 py-1.5 rounded-md shadow-md text-xs font-medium text-[color:var(--brand)] flex items-center gap-1 hover:bg-white transition-colors"
      >
        <ExternalLink size={13} /> Open in Google Maps
      </a>
      <div className="absolute bottom-3 left-3 bg-[color:var(--brand)] text-white px-3 py-1.5 rounded-md shadow-md text-xs font-medium flex items-center gap-1">
        <MapPin size={13} /> {title}
      </div>
    </div>
  );
}
